/* global wp */
import { get } from 'lodash'
import AuthForm from './../elements/auth-form'

const { __ } = wp.i18n

const GoogleForm = () => {
	return (
		<AuthForm action={get(window, 'hubConnectorVars.login.google_auth_url', '')}>
			<input type="hidden" name="context" value="connect"/>
			<button className="sui-button dashui-google-login-button" type="submit">
				<span className="sui-icon-google-login" aria-hidden="true"></span>
				{__('Sign in with Google', 'wpmudev')}
			</button>
		</AuthForm>
	)
}

export default GoogleForm
